import { useTheme } from '@emotion/react';
import { Box } from '@mui/material';

import Hero from '../../components/home/Hero';
import Why from '../../components/home/Why';
import How from '../../components/home/How';
import What from '../../components/home/What';
import Who from '../../components/home/Who';
import useTitle from '../../hooks/useTitle';

export default function Home() {
  const theme = useTheme();
  useTitle();
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        [theme.breakpoints.down('md')]: {
          mt: '94px',
        },
      }}
    >
      <Hero />
      <Why />
      <How />
      <What />
      <Who />
    </Box>
  );
}
